export default function FormButton(props) {
  return (
    <span onClick={props.onclick} className={`cursor-pointer inline-block ${props.classes}`}>{props.children}</span>
  );
}
